<template>
  <div
    class="d2-list-chart-card"
    @mouseover="showReport()"
    @mouseout="hideReport()"
    :style="guideStep == 7 ? { zIndex: 100, position: 'relative' } : { position: 'relative' }"
  >
    <loading :active="!this.showChart"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <h5 class="d2-list-chart-title">{{ title }}</h5>
    <Chart
      type="line"
      :data="lineStylesData"
      :options="basicOptions"
    />
  </div>
</template>

<script>

import { ref, computed } from 'vue';
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";

export default {
  name: 'EventsListChart',
  components: {
    Loading
  },
  props: {
    guideStep: {
      type: Number,
      default: -1
    },
    showChart: {
      type: Boolean
    },
    title: {
      type: String,
      default: 'xxx'
    },
    chartsData: {
      type: Object,
      default: () => ({
        labels: [],
        datasets: []
      })
    },
    /* tableData: {
      type: Array,
      default: () => []
    } */
  },
  setup(props) {
    const reportShow = ref(false);

    const basicOptions = computed(() => ({
      legend: {
        position: 'bottom',
        /* eslint-disable */
        onClick: function(e, legendItem) {
          let index = legendItem.datasetIndex;
          let ci = this.chart;
          let meta = ci.getDatasetMeta(index);

          // See controller.isDatasetVisible comment
          if (legendItem.text !== undefined && legendItem.text !== '優化建議') {
            meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
          }
          // We hid a dataset ... rerender the chart
          ci.update();
        },
        /* eslint-disable */
        labels: {
          filter: function(e) {
            return e.text !== undefined;
          }
        }
      },
      tooltips: {
        mode: 'index',
        // intersect: false,
        position: 'nearest',
        filter: function(e) {
          const optimizeDatasetsCounts = 0;
          return e.datasetIndex >= optimizeDatasetsCounts;
        }
      },
      plugins: {
        legend: {
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        xAxes: [{
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'YYYY/MM/DD'
            }
          }
        }],
        x: {
          ticks: {
            color: '#f02222',
          },
        },
        y: {
          ticks: {
            color: '#f02222'
          },
        }
      }
    }));

    const lineStylesData = computed(() => {

      // console.log('props.chartsData');
      // console.log(props.chartsData);

      // console.log('props.showChart:'+props.showChart);

      //if (props.tableData.length <= 0) {
      return props.chartsData;
      /* } else {
        // 圖畫最大值
        const maxDataArray = [];
        props.chartsData.datasets.map((e) => {
          maxDataArray.push(Math.max(...e.data.map(p => p.y)));
        });
        const maxData = 20 - Math.max(...maxDataArray) % 20 > 0 ? Math.max(...maxDataArray) + 20 - Math.max(...maxDataArray) % 20 : Math.max(...maxDataArray);

        let optimizeDatasets = [];
        for (let idx = 0; idx < props.tableData.length; idx++) {
          let item = {
            data: [
              {
                x: new Date(props.tableData[idx].since),
                y: 0
              },
              {
                x: new Date(props.tableData[idx].since),
                y: maxData
              }
            ],
            pointRadius: 0,
            fill: false,
            borderColor: '#B9BDCD',
            pointHoverBackgroundColor: '#FA9E76',
            tension: .4,
            showLine: true
          }
          if (idx === 0) {
            item.label = '優化建議';
          }
          optimizeDatasets.push(item);
        }
        let finial = {...props.chartsData};
        finial.datasets = [...optimizeDatasets, ...finial.datasets];
        console.log(finial);
        return finial;
        // return props.chartsData;
      } */

    });

    const showReport = () => {
      reportShow.value = true;
    };

    const hideReport = () => {
      reportShow.value = false;
    }

    return {
      reportShow,
      lineStylesData,
      basicOptions,
      showReport,
      hideReport
    }
  }
};
</script>

<style lang="css" scoped>

/* panel / h5 樣式已由 d2-list-chart-card / d2-list-chart-title 全局 CSS 取代 */


</style>
